import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { getEvaluaciones } from '../../riesgo-liquidez/query';
import { getDetalleEvaluacionVarTemp } from './query';
import { ObtenerIds } from '../../../elements/financiero-alerta/idsTablas';
import { getAnio, getCuentasProm, getDetalleCuenta, getVariable, getVarTemp, getVarTempDes } from '../indicadores-cobertura/query';


@Injectable({
  providedIn: 'root'
})
export class CoberturaService {
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private cookieService: CookieService,
    private apollo: Apollo
  ) { }

  /**
 * Obtiene las evaluaciones por plantilla
 */
  async getEvaluacionesByPlantilla(idPlantilla: number) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getEvaluaciones,
          context: { headers: this.headers },
          variables: { idPlantilla: idPlantilla }
        }).valueChanges
      );
      return data.evaluaciones;
    } catch (err) {

    }
  }

  /**
   * Obtiene el detalle de evaluación con variables temporales
   */
  async getDetalleEvaluacion(idEvaluacion: number) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getDetalleEvaluacionVarTemp,
          context: { headers: this.headers },
          variables: {
            idEvaluacion: idEvaluacion,
            idVarTemp: ObtenerIds.idsVarTemp(0),
            idVarTemp2: ObtenerIds.idsVarTemp(1),
            idVarTemp3: ObtenerIds.idsVarTemp(2)
          }
        }).valueChanges
      );
      return {
        valor1: data.valor1,
        valor2: data.valor2,
        valor3: data.valor3
      };
    } catch (err) {
      return null;
    }
  }

  /**
   * Obtiene detalles de evaluaciones múltiples en paralelo
   */
  async getMultiplesDetalleEvaluacion(cadenaEvaluacion: any[]) {
    const promises = [];
    for (const eva of cadenaEvaluacion) {
      const promise = this.getDetalleEvaluacion(eva.idEvaluacion);
      promises.push(promise);
    }
    return await Promise.all(promises);
  }

  /**
   * Obtiene las descripciones de variables temporales
   */
  async getVarTempDes(idPlantilla: number) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVarTempDes,
          context: { headers: this.headers },
          variables: {
            idPlantilla: idPlantilla,
            varTempId: ObtenerIds.idsVarTemp(0),
            varTempId2: ObtenerIds.idsVarTemp(1),
            varTempId3: ObtenerIds.idsVarTemp(2)
          }
        }).valueChanges
      );
      return {
        valor1: data.valor1,
        valor2: data.valor2,
        valor3: data.valor3
      };
    } catch (err) {
      return null;
    }
  }

  /**
   * Obtiene el año y datos de cobertura por evaluación
   */
  async getAnioPorEvaluacion(idEvaluacion: number) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getAnio,
          context: { headers: this.headers },
          variables: {
            "idVarTemp": "VT049",
            "idVarTemp2": "VT038",
            "idEvaluacion": idEvaluacion
          }
        }).valueChanges
      );
      return data.valor1.valor - data.valor2.valor;
    } catch (err) {
      return null;
    }
  }

  /**
   * Obtiene años de cobertura para múltiples evaluaciones
   */
  async getMultiplesAños(evaluacionesIds: any[]) {
    const promises = [];
    for (const id of evaluacionesIds) {
      const promise = this.getAnioPorEvaluacion(id);
      promises.push(promise);
    }
    return await Promise.all(promises);
  }
    /**
   * Obtiene detalle de cuenta
   */
  async getDetalleCuenta(idEvaluacion: number, idCuenta: string) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getDetalleCuenta,
          context: { headers: this.headers },
          variables: { idEvaluacion: idEvaluacion, idCuenta: idCuenta }
        }).valueChanges
      );
      return data;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  /**
   * Obtiene variable
   */
  async getVariable(idEvaluacion: number, idVariable: string) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVariable,
          context: { headers: this.headers },
          variables: { idEvaluacion: idEvaluacion, idVariable: idVariable }
        }).valueChanges
      );
      return data;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  /**
   * Obtiene variable temporal
   */
  async getVarTemp(idEvaluacion: number, idVarTemp: string) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVarTemp,
          context: { headers: this.headers },
          variables: { idEvaluacion: idEvaluacion, idVarTemp: idVarTemp }
        }).valueChanges
      );
      return data;
    } catch (err) {
      console.log(err);
      return null;
    }
  }
  /**
   * Obtiene cuentas promedio múltiples
   */
  async getCuentasProm(variables: any) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getCuentasProm,
          context: { headers: this.headers },
          variables: variables
        }).valueChanges
      );
      return data;
    } catch (err) {
      console.log(err);
      return null;
    }
  }
}
